(function () {
  function ready(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  }

  function setCounts() {
    var roles = Array.from(document.querySelectorAll('[data-nnc-role]'));
    var openings = roles.reduce(function (total, role) {
      return total + (parseInt(role.dataset.openings || '1', 10) || 1);
    }, 0);
    document.querySelectorAll('[data-nnc-role-count]').forEach(function (node) { node.textContent = roles.length; });
    document.querySelectorAll('[data-nnc-position-count]').forEach(function (node) { node.textContent = openings; });
    ['core', 'project', 'commercial'].forEach(function (path) {
      var count = roles.filter(function (role) { return role.dataset.path === path; }).length;
      document.querySelectorAll('[data-nnc-path-count="' + path + '"]').forEach(function (node) {
        node.textContent = count + (count === 1 ? ' role' : ' roles');
      });
    });
  }

  function initHeroVideos(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.nnc-hero-video').forEach(function (video) {
      if (video.dataset.nncVideoReady === 'true') return;
      video.dataset.nncVideoReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      function revealVideo() {
        video.classList.add('is-ready');
      }
      video.addEventListener('loadeddata', revealVideo, { once: true });
      video.addEventListener('canplay', revealVideo, { once: true });
      video.addEventListener('playing', revealVideo, { once: true });
      if (video.readyState >= 2) revealVideo();

      var playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === 'function') playAttempt.catch(function () {});
    });
  }

  function initRoleSection(section) {
    if (section.dataset.nncReady === 'true') return;
    section.dataset.nncReady = 'true';
    var roles = Array.from(section.querySelectorAll('[data-nnc-role]'));
    var search = section.querySelector('[data-nnc-search]');
    var chips = Array.from(section.querySelectorAll('[data-nnc-filter]'));
    var count = section.querySelector('[data-nnc-result-count]');
    var empty = section.querySelector('[data-nnc-empty]');
    var activeFilter = 'all';

    function applyFilters() {
      var query = (search && search.value || '').trim().toLowerCase();
      var shown = 0;
      roles.forEach(function (role) {
        var pathMatch = activeFilter === 'all' || role.dataset.path === activeFilter;
        var searchMatch = !query || (role.dataset.search || role.textContent).toLowerCase().indexOf(query) !== -1;
        role.hidden = !(pathMatch && searchMatch);
        if (!role.hidden) shown += 1;
      });
      if (count) count.textContent = shown + (shown === 1 ? ' role' : ' roles');
      if (empty) empty.hidden = shown !== 0;
    }

    if (search) search.addEventListener('input', applyFilters);
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        activeFilter = chip.dataset.nncFilter;
        chips.forEach(function (item) { item.setAttribute('aria-pressed', item === chip ? 'true' : 'false'); });
        applyFilters();
      });
    });

    document.querySelectorAll('[data-nnc-path]').forEach(function (pathButton) {
      pathButton.addEventListener('click', function () {
        activeFilter = pathButton.dataset.nncPath;
        chips.forEach(function (item) { item.setAttribute('aria-pressed', item.dataset.nncFilter === activeFilter ? 'true' : 'false'); });
        applyFilters();
        section.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    });
    applyFilters();
  }

  function initModals() {
    document.addEventListener('click', function (event) {
      var open = event.target.closest('[data-nnc-open-role]');
      if (open) {
        var source = document.getElementById(open.getAttribute('aria-controls'));
        var modal = document.querySelector('[data-nnc-modal]');
        var content = modal && modal.querySelector('[data-nnc-modal-content]');
        if (!source || !modal || !content) return;
        content.innerHTML = source.innerHTML;
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('nnc-modal-open');
        var close = modal.querySelector('[data-nnc-close]');
        if (close) close.focus();
      }
      if (event.target.closest('[data-nnc-close]') || event.target.matches('[data-nnc-modal-scrim]')) closeModal();
      var apply = event.target.closest('[data-nnc-apply-role]');
      if (apply) {
        closeModal();
        var role = apply.dataset.nncApplyRole || '';
        prefillCareerRole(role);
      }
    });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeModal(); });
  }

  function closeModal() {
    var modal = document.querySelector('[data-nnc-modal]');
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nnc-modal-open');
  }

  function initNativeApplications(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('[data-nnc-native-application]').forEach(function (application) {
      if (application.dataset.nncReady === 'true') return;
      application.dataset.nncReady = 'true';
      var select = application.querySelector('[data-nnc-native-role]');
      var question = application.querySelector('[data-nnc-role-question]');
      var answer = application.querySelector('[data-nnc-role-answer]');
      if (!select) return;

      var specialOptions = Array.from(select.querySelectorAll('[data-nnc-special-option]')).map(function (option) {
        return { value: option.value, label: option.textContent };
      });
      var roles = Array.from(document.querySelectorAll('[data-nnc-role]')).map(function (role) {
        return {
          title: role.dataset.roleTitle || (role.querySelector('.nnc-role-title') || {}).textContent || '',
          question: role.dataset.roleQuestion || '',
          engagement: role.dataset.roleEngagement || ''
        };
      }).filter(function (role) { return role.title; });

      select.innerHTML = '';
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = 'Select an opportunity';
      select.appendChild(placeholder);
      roles.forEach(function (role) {
        var option = document.createElement('option');
        option.value = role.title;
        option.textContent = role.title + (role.engagement ? ' — ' + role.engagement : '');
        option.dataset.question = role.question;
        select.appendChild(option);
      });
      specialOptions.forEach(function (special) {
        var option = document.createElement('option');
        option.value = special.value;
        option.textContent = special.label;
        select.appendChild(option);
      });

      function updateQuestion() {
        var selected = select.options[select.selectedIndex];
        var prompt = selected && selected.dataset.question;
        if (!prompt && select.value === 'Creative collaboration proposal') prompt = 'What would you like to make, what would each side contribute, and how could the work be used?';
        if (!prompt && select.value === 'Talent network — no specific role') prompt = 'What kind of work are you looking for, and what should we keep you in mind for?';
        if (!prompt) prompt = 'Select an opportunity above to see its question.';
        if (question) question.textContent = prompt;
        if (answer) answer.placeholder = select.value ? 'Write your response here.' : '';
      }
      select.addEventListener('change', updateQuestion);
      updateQuestion();
    });
  }

  function prefillCareerRole(role) {
    if (!role) return;
    var nativeField = document.querySelector('[data-nnc-native-role]');
    if (nativeField) {
      var nativeOption = Array.from(nativeField.options).find(function (item) {
        return item.value.toLowerCase() === role.toLowerCase() || item.textContent.trim().toLowerCase() === role.toLowerCase();
      });
      if (nativeOption) nativeField.value = nativeOption.value;
      nativeField.dispatchEvent(new Event('input', { bubbles: true }));
      nativeField.dispatchEvent(new Event('change', { bubbles: true }));
      window.setTimeout(function () { nativeField.focus({ preventScroll: true }); }, 350);
      return;
    }
    var attempts = 0;
    function fill() {
      attempts += 1;
      var fields = Array.from(document.querySelectorAll('[data-nnc-klaviyo-form] input, [data-nnc-klaviyo-form] select, [data-nnc-klaviyo-form] textarea'));
      var field = fields.find(function (item) {
        var identity = [item.name, item.id, item.getAttribute('aria-label'), item.placeholder].filter(Boolean).join(' ').toLowerCase().replace(/[^a-z]+/g, ' ').trim();
        return identity === 'application role' || identity === 'role' || identity === 'role selected' || identity === 'career role';
      });
      if (field) {
        if (field.tagName === 'SELECT') {
          var option = Array.from(field.options).find(function (item) {
            return item.value.toLowerCase() === role.toLowerCase() || item.textContent.trim().toLowerCase() === role.toLowerCase();
          });
          if (option) field.value = option.value;
        } else {
          field.value = role;
        }
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      if (attempts < 12) window.setTimeout(fill, 250);
    }
    fill();
  }

  function init(root) {
    setCounts();
    initHeroVideos(root);
    root.querySelectorAll ? root.querySelectorAll('[data-nnc-role-section]').forEach(initRoleSection) : null;
    initNativeApplications(root);
  }

  ready(function () {
    init(document);
    initModals();
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  });
})();
